import {connect} from 'react-redux';
import {formValueSelector} from 'redux-form';
import EntryDetailEventChangeModal from './EntryDetailEventChangeModal.jsx';
import {
  handleEventChangeSave,
  handleEventChangeCancel
} from './actions';

const selector = formValueSelector('adminEntryDetailEventChangeForm');

const mapStateToProps = state => ({
  visible: state.admin.entryDetail.showEventChangeModal,
  availableEvents: selector(state, 'availableEvents')
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(handleEventChangeSave(data)),
  onCancel: () => dispatch(handleEventChangeCancel())
});

export default connect(mapStateToProps, mapDispatchToProps)(EntryDetailEventChangeModal);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryDetailEventChangeModalContainer.jsx